// Sentinel the explore filter UI sends to mean "this field has no value".
export const BLANK_CUSTOM_META_VALUE = '_blank'

// A `custom_meta` filter value arrives in several shapes: a bare string from a
// single-select field, an array from a multi-select, and an index-keyed object
// ({0: 'Alpha'}) once a multi-select has round-tripped through the URL as
// `custom_meta[Field][0]=Alpha`. Normalize them all to a flat array.
export function customMetaFilterValues(value) {
    if (value === null || value === undefined || value === '') return []
    if (Array.isArray(value)) return value.filter(v => v !== null && v !== undefined && v !== '')
    if (typeof value === 'object') return customMetaFilterValues(Object.values(value))

    return [value]
}
